import type { CSSProperties } from "react";

/** Design tokens.
 *
 *  Tailwind was recommended and then deliberately dropped: the approved design
 *  was already expressed as this token object with inline styles, and porting it
 *  meant arbitrary-value classes or a v4 theme config — churn and risk for
 *  identical output. Reversible if that preference changes.
 *
 *  The palette is built on the deep navy the Church has used historically. Brass
 *  rather than red carries the "due to speak" signal, because three years
 *  without speaking is a signal, not an error.
 */
export const T = {
  navy: "#0B2545",
  navy2: "#14395E",
  accent: "#3E7CB1",
  accentSoft: "#E8F0F7",
  paper: "#F4F6F9",
  line: "#E3E8EF",
  brass: "#A8823C",
  brassSoft: "#F5EEDF",
  brassLine: "#EADFC6",
  ink: "#16283F",
  muted: "#6B7A8D",
  faint: "#9AA7B6",
} as const;

/** Shared text-input style.
 *
 *  16px is deliberate and load-bearing: anything smaller makes iOS Safari zoom
 *  the viewport when the field takes focus.
 */
export const inputStyle: CSSProperties = {
  width: "100%",
  padding: "11px 12px",
  borderRadius: 9,
  border: `1px solid ${T.line}`,
  background: "#fff",
  color: T.ink,
  fontSize: 16,
};
